export const ITEM_FETCH = "ITEM_FETCH";
export const ITEM_CREATE = "ITEM_CREATE";
export const ITEM_UPDATE = "ITEM_UPDATE";
export const ITEM_DELETE = "ITEM_DELETE";

export const SET_ROLE = "SET_ROLE";

export const USER_CLEAR_ERROR = "USER_CLEAR_ERROR";

export const USER_CHECKING = "USER_CHECKING";
export const USER_SUCCESS = "USER_SUCCESS";
export const USER_LOGOUT = "USER_LOGOUT";
export const USER_ERROR = "USER_ERROR";

export const TOKEN_CHECKING = "TOKEN_CHECKING";
export const TOKEN_SET_USER = "TOKEN_SET_USER";
export const TOKEN_VERIFIED = "TOKEN_VERIFIED";
export const TOKEN_EMPTY = "TOKEN_EMPTY";
export const TOKEN_ERROR = "TOKEN_ERROR";

export const ROOM_CLEAR_ERROR = "ROOM_CLEAR_ERROR";

export const ROOM_LOADING = "ROOM_LOADING";
export const ROOM_VALIDATION_SUCCESS = "ROOM_VALIDATION_SUCCESS";
export const ROOM_LEAVE = "ROOM_LEAVE";
export const ROOM_ERROR = "ROOM_ERROR";
export const ROOM_SENT_MESSAGE = "ROOM_SENT_MESSAGE";
export const ROOM_RECEIVED_MESSAGE = "ROOM_RECEIVED_MESSAGE";

export const BLACK_MOVED = "BLACK_MOVED";
export const WHITE_MOVED = "WHITE_MOVED";
export const BLACK_CASTLED = "BLACK_CASTLED";
export const WHITE_CASTLED = "WHITE_CASTLED";

export const WHITE_PROMOTED_BY_MOVE = "WHITE_PROMOTED_BY_MOVE";
export const BLACK_PROMOTED_BY_MOVE = "BLACK_PROMOTED_BY_MOVE";
export const WHITE_PROMOTED_BY_CAPTURE = "WHITE_PROMOTED_BY_CAPTURE";
export const BLACK_PROMOTED_BY_CAPTURE = "BLACK_PROMOTED_BY_CAPTURE";

export const BLACK_CAPTURED_WHITE = "BLACK_CAPTURED_WHITE";
export const WHITE_CAPTURED_BLACK = "WHITE_CAPTURED_BLACK";

export const WHITE_PIECE_PROMOTED = "WHITE_PIECE_PROMOTED";
export const BLACK_PIECE_PROMOTED = "BLACK_PIECE_PROMOTED";
export const SET_WHITE_CASTLE_STATE = "SET_WHITE_CASTLE_STATE";
export const SET_BLACK_CASTLE_STATE = "SET_BLACK_CASTLE_STATE";
export const ADD_HISTORY = "ADD_HISTORY";
export const RESET_HISTORY = "RESET_HISTORY";
export const INITIAL_BOARD = "INITIAL_BOARD";
export const SET_GAME_OVER = "SET_GAME_OVER";
